import { ROLES } from '../constants/roles';
import { canApprove } from './roleHierarchy';
import { isAmMroConsecutiveBlocked } from './amMroConsecutiveApproval';

export const PO_EDITABLE_STATUSES = ['DRAFT', 'PENDING_STORE_APPROVAL', 'PENDING_AM_APPROVAL'];

export const PO_APPROVAL_CORRECTION_STATUSES = ['PENDING_STORE_APPROVAL', 'PENDING_AM_APPROVAL'];

export function requiresCorrectionNoteOnEdit(status) {
  return PO_APPROVAL_CORRECTION_STATUSES.includes(status);
}

/**
 * Whether the user may open the PO edit form for the given status.
 * Store roles may edit during draft / pending approvals.
 * Managers with store-approval authority may edit at PENDING_STORE_APPROVAL.
 * Accountable Manager and Super Admin may edit at PENDING_AM_APPROVAL (corrections before final issue).
 */
export function canEditPurchaseOrder(role, status) {
  if (!role || !PO_EDITABLE_STATUSES.includes(status)) return false;

  if ([ROLES.SUPER_ADMIN, ROLES.ACCOUNTABLE_MANAGER, ROLES.AM_MRO, ROLES.STORE_EXECUTIVE, ROLES.STORE_INSPECTOR].includes(role)) {
    return true;
  }

  if (status === 'PENDING_STORE_APPROVAL' && canApprove(role)) {
    return true;
  }

  if (status === 'PENDING_AM_APPROVAL' && [ROLES.ACCOUNTABLE_MANAGER, ROLES.AM_MRO, ROLES.SUPER_ADMIN].includes(role)) {
    return true;
  }

  return false;
}

export function canApproveStorePurchaseOrder(role, status) {
  return status === 'PENDING_STORE_APPROVAL' && canApprove(role);
}

export function canApproveAmPurchaseOrder(role, status, purchaseOrder, user) {
  if (status !== 'PENDING_AM_APPROVAL') return false;
  if (![ROLES.ACCOUNTABLE_MANAGER, ROLES.AM_MRO, ROLES.SUPER_ADMIN].includes(role)) return false;
  if (user && isAmMroConsecutiveBlocked(user, purchaseOrder?.storeApprovedBy)) return false;
  return true;
}

/** Super Admin may permanently delete any PO regardless of status (RECEIVED, CLOSED, etc.). */
export function canSuperAdminDeletePurchaseOrder(role) {
  return role === ROLES.SUPER_ADMIN;
}
